// AUTO-GENERATED from prompts/chat-prompts.yaml.
// Do not edit by hand — run `npm run gen:prompts` or restart `npm run dev`.

export interface ReActTraceStep { kind: "think" | "act" | "observe"; text: string }
export interface CitedNode { id: string; label: string; kind: string }
export interface PromptAction { label: string; icon: string; tone?: "primary" | "ghost" }
export interface CatalogedPrompt {
  id: string;
  label: string;
  icon: string;
  q: string;
  match: RegExp[];
  /** Template surface — the live agent renders these into a JSON envelope. */
  system: string;
  template: string;
  slots: readonly string[];
  tools_allowed: readonly string[];
  output_schema: string;
}

const _raw: Array<Omit<CatalogedPrompt, "match"> & { match: string[] }> =
  [
  {
    "id": "why-late",
    "label": "Why is a milestone at risk?",
    "icon": "Flag",
    "q": "Why is the lighting milestone showing red?",
    "match": [
      "/late|delay/i",
      "/risk|red|stuck/i",
      "/milestone|install|handover/i"
    ],
    "system": "You are FoyrMind. Speak in the {{designer_voice}} voice. Explain why a milestone is at risk and propose at most one substitute that respects the project's Intent + budget. Cite the rule fired and the candidate SKU graph node by IRI.",
    "template": "Project: {{project_iri}} Milestone at risk: {{milestone_iri}} (due in {{milestone_due_in_days}} d) Lead-time buffer: {{lead_time_buffer_days}} d Recent memory (top {{memory_top_k}}): {{memory_context}} Walk BLOCKED_BY edges from the milestone; pick the rule that fires soonest; propose a substitute SKU minimising lead time.",
    "slots": [
      "project_iri",
      "milestone_iri",
      "milestone_due_in_days",
      "lead_time_buffer_days",
      "memory_top_k",
      "memory_context",
      "designer_voice"
    ],
    "tools_allowed": [
      "graph.walk",
      "memory.recall",
      "substitute.score"
    ],
    "output_schema": "shared.output_envelope"
  },
  {
    "id": "budget-cut",
    "label": "What happens if the budget changes?",
    "icon": "IndianRupee",
    "q": "Client wants to cut the budget 12%. What breaks?",
    "match": [
      "/budget/i",
      "/cut|drop|reduce|raise|increase/i",
      "/\\\\b\\\\d{1,2}\\\\s?%/",
      "/over.?run/i"
    ],
    "system": "You are FoyrMind. Solve a budget-redistribution problem in the {{designer_voice}} voice. List the BudgetLine triples that breach and a redistribution path that respects the cohesion tolerance the studio's Intent declares.",
    "template": "Project: {{project_iri}} Current cap: {{current_cap}} Cut requested: {{cut_percent}}% (parsed from the user's question) Budget-line target: {{budget_line_target}} Cohesion tolerance (pp): {{cohesion_tolerance_pp}} Recent memory (top {{memory_top_k}}): {{memory_context}} Find every BudgetLine that exceeds its share post-cut; solve a redistribution within tolerance.",
    "slots": [
      "project_iri",
      "current_cap",
      "cut_percent",
      "budget_line_target",
      "cohesion_tolerance_pp",
      "memory_top_k",
      "memory_context",
      "designer_voice"
    ],
    "tools_allowed": [
      "graph.walk",
      "budget.solver",
      "memory.recall"
    ],
    "output_schema": "shared.output_envelope"
  },
  {
    "id": "pre-render",
    "label": "Before I render — anything to fix?",
    "icon": "Camera",
    "q": "I'm about to Take Render on a room — anything to fix first?",
    "match": [
      "/render/i",
      "/style/i",
      "/cohesion/i",
      "/before/i"
    ],
    "system": "You are FoyrMind. PRE-render style audit in the {{designer_voice}} voice. Compute cohesion vs Intent threshold; flag the worst-offending SKU; propose a restyle. Refuse to encourage rendering when cohesion is below the threshold.",
    "template": "Project: {{project_iri}} Style cohesion threshold: {{style_cohesion_threshold}} Recent memory (top {{memory_top_k}}): {{memory_context}} Rank rooms by cohesion (ascending); for the worst, walk IN_ROOM to find the SKU with the lowest MATCHES_STYLE weight; propose a restyle or accept if within tolerance.",
    "slots": [
      "project_iri",
      "style_cohesion_threshold",
      "memory_top_k",
      "memory_context",
      "designer_voice"
    ],
    "tools_allowed": [
      "graph.walk",
      "style.cohesion_score",
      "memory.recall"
    ],
    "output_schema": "shared.output_envelope"
  },
  {
    "id": "approval-aged",
    "label": "Any approvals going stale?",
    "icon": "ShieldCheck",
    "q": "Anything stuck waiting for client approval?",
    "match": [
      "/approval/i",
      "/pending/i",
      "/stale|stuck/i",
      "/client.*wait/i"
    ],
    "system": "You are FoyrMind. Surface stale approvals in the {{designer_voice}} voice. Use the studio's age-threshold env value; never invent a number. Draft a follow-up packet only when asked; default action is to summarise and offer to draft.",
    "template": "Project: {{project_iri}} Approval age threshold (days): {{approval_age_days}} Recent memory (top {{memory_top_k}}): {{memory_context}} Walk Approval nodes; return any whose age >= threshold; sort by age descending; cite the source.",
    "slots": [
      "project_iri",
      "approval_age_days",
      "memory_top_k",
      "memory_context",
      "designer_voice"
    ],
    "tools_allowed": [
      "graph.walk",
      "memory.recall",
      "draft.packet"
    ],
    "output_schema": "shared.output_envelope"
  }
];

export const CHAT_PROMPTS: CatalogedPrompt[] = _raw.map((p) => ({
  ...p,
  match: p.match.map((s) => {
    const m = s.match(/^\/(.+)\/([gimsuy]*)$/);
    return m && m[1] !== undefined ? new RegExp(m[1], m[2]) : new RegExp(s);
  }),
}));
